<template>
  <div class="row item_box">
    <div class="imageview">
      <img
        class="image_box justify-start"
        v-if="list.imageurl"
        alt="image"
        :src="list.imageurl"
      />
      <img
        class="justify-start image_box"
        v-if="!list.imageurl"
        src="../assets/img/no_item_image.jpeg"
        alt="image"
      />
    </div>
    <div class="col column-padding">
      <div class="item_text" >
        <p>{{list.name}}</p>
      </div>
      <read-more
        class="text_body"
        :more-str="$t('newUi.adminViewform.readMore')"
        :text="list.desc"
        link="#"
        :less-str="$t('newUi.adminViewform.readLess')"
        :max-chars="50"
      ></read-more>
      <div class="d-flex justify-space-between">
        <div class="item_text justify-start itemprice_catalogue">
          <span style="margin-right: 3px">{{payload.symbol}}</span>{{parseFloat(list.price).toFixed(2)}}
        </div>
        <div class="justify-end">
          <v-checkbox class="isordered" @change="recalcTotal" v-model="list.isOrdered"
            >&nbsp;</v-checkbox
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../store/store';
export default {
  props: ["payload", "list"],
  // components: {
  //         NumInp
  //     },
  data() {
    return {
      dialog: false,
      edit_product: false,
      edit_category: false,
      delete_product: false,
    };
  },
  methods: {
    recalcTotal: function (event) {
      if (event == true) {
        this.list.isOrdered = true;
        for (var item of this.payload.catalogue) {
          if (item.pos == this.list.pos) {
            item.isOrdered = true;
            item.qtty = 1;
            this.recalcTotall();
          }
        }
      } else {
        this.list.isOrdered = false;
        for (var cat_item of this.payload.catalogue) {
          if (cat_item.pos == this.list.pos) {
            cat_item.isOrdered = false;
            cat_item.qtty = 0;
            this.recalcTotall();
          }
        }
      }

      this.recalcTotall();
    },
    recalcTotall: function () {
      var total = 0;
      var qty=0;
      var form = this.payload;
      // console.log(form);
      for (var i = 0; i < form.catalogue.length; i++) {
        var curitem = form.catalogue[i];
        // console.log(curitem.type);
        if (curitem.type !== "item") continue;
        if (curitem.isOrdered) {
          total += 1 * curitem.price;
          qty+= curitem.qtty;
        } else if (curitem.qtty > 0) {
          total += curitem.qtty * curitem.price;
          qty+= curitem.qtty;
        }
      }
      document.getElementById('item').innerText=qty;
      document.getElementById('total').innerText=parseFloat(total).toFixed(2);
      document.getElementById('Mob_item').innerText=qty;
      document.getElementById('Mob_total').innerText=parseFloat(total).toFixed(2);
      form.amount = total;
      // console.log(form);
      this.payload.amount = total;
    },
  },
};
</script>
<style lang="scss">
.v-application p {
  margin-bottom: 0px;
}
/* .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: white;
    background-color: #8AB26D;
    border-radius: 5px;
} */
.bottom_modal {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.v-input__control {
  display: contents;
}
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.text_bold {
  font-weight: 500;
}
.itemprice_catalogue {
  display: flex;
  align-items: center;
}
@media (min-width: 960px) {
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #31333e;
    border-radius: 5px;
  }
  .item_text {
    word-break: break-all;
    min-height:35px;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1px;
  }
  .text_body {
    min-height:35px;
    font-size: 12px;
    letter-spacing: 0px;
    word-break: break-word;
    color: #666666;
  }
  #readmore {
    color: #8ab26d;
  }
  .item_box {
    padding: 0px;
    margin: 12px 0px;
    background-color: #f8faf7;
    border-radius: 5px;
  }
}
@media (min-width: 320px) and (max-width: 960px) {
  .item_category {
    padding: 5px;
    margin: 12px 0px;
    color: #fff;
    background-color: #8ab26d;
    border-radius: 5px;
  }
  .item_text {
    word-break: break-all;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #666666;
    opacity: 1px;
  }
  .text_body {
    font-size: 12px;
    letter-spacing: 0px;
    word-break: break-word;
    color: #666666;
  }
  #readmore {
    color: #8ab26d;
  }
  .image_box {
    max-width: 250px;
    /*width: 100%;*/
    max-height: 150px;
  }
}

@media (min-width: 960px) {
  .imageview {
    width: 100%;
    height: 150px;
    display: flex;
    justify-content: center;
  }
}
</style>
